import { Button, Flex, Heading, Text } from "rebass/styled-components"
import Select from 'react-select';
import { IHealthCoachFormTemplatesOutput, IHealthCoachFormTemplatesTarget } from "../../../graphql/types/queries/forms"
import { useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { Form, Formik } from "formik";
import * as Yup from 'yup';
import { IFormMeta } from "./Builder";
import FormField from "../../../components/FormField";
import { TextInputWithLabel } from "../../../components/TextInput";

const Item = styled(Flex)`
  padding: 8px 12px;
  border: 1px solid #a1abbc;
  border-radius: 10px;
  margin-left: 12px;
  cursor: pointer;

  &:hover {
    border: 1px solid rgb(52, 79, 121);
    background: rgb(52, 79, 121);
    color: white;
  }
`
const schema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(2, 'Question must be greater than 1 character')
    .required('Required'),
});
interface IProps {
  templates: Array<IHealthCoachFormTemplatesOutput>
  onSelected: (template: IHealthCoachFormTemplatesOutput, meta: IFormMeta) => void
  forceTemplateId?: string | null | undefined
  forceTargetId?: string | null | undefined
}

const getTemplateTargets = (templates: Array<IHealthCoachFormTemplatesOutput>, forceTargetId?: string | null | undefined) => {
  const res: Array<IHealthCoachFormTemplatesTarget> = []

  for (let index = 0; index < templates.length; index++) {
    const element = templates[index];
    if (!!forceTargetId && element.target.id !== forceTargetId) continue
    if (res.findIndex(x => x.id === element.target.id) < 0) {
      res.push(element.target)
    }
  }

  return res.map(x => {
    return {
      label: x.target,
      value: x.id
    }
  })
}
const PickTemplate: React.FC<IProps> = ({
  templates,
  onSelected,
  forceTemplateId,
  forceTargetId
}) => {
  const [targets, setTargets] = useState(getTemplateTargets(templates, forceTargetId))
  const [selectedTarget, setSelectedTarget] = useState<{ label: string, value: string } | null | undefined>(!!forceTargetId ? getTemplateTargets(templates, forceTargetId)[0] : null)
  const [selectedTemplate, setSelectedTemplate] = useState<IHealthCoachFormTemplatesOutput | null | undefined>(!!forceTemplateId ? templates.find(x => x.id === forceTemplateId) : null)
  console.log({ templates })
  return (
    <Flex flexDirection={'column'} flex={1} p={4} maxWidth={'600px'} margin={'0 auto'}>
      <Heading mb={4} textAlign={'center'}>Create a new form</Heading>
      {(!forceTargetId || !forceTemplateId) && (
        <>
          <Text mb={3} fontStyle={'italic'} textAlign={'center'}>You must select a template to base your form on.</Text>
          <Text fontWeight={600} mb={3}>Target:</Text>
          <div style={{ maxWidth: '500px', width: '100%' }}>
            <Select
              classNamePrefix="region-select"
              options={targets}
              value={selectedTarget}
              isDisabled={!!forceTargetId}
              onChange={(e: any) => setSelectedTarget(e)}
              noOptionsMessage={() => (
                <div style={{ padding: '12px 24px' }}>
                  <Text textAlign="left" mb={2} fontSize="16px" fontWeight="400">
                    No target selected
                  </Text>
                </div>
              )}
              theme={(base) => ({
                ...base,
                colors: {
                  ...base.colors,
                  primary: '#364f79',
                  primary50: '#dae6fa',
                },
              })} />
          </div>
          {!!selectedTarget && (
            <>
              <Text fontWeight={600} mb={3} mt={4}>Select a template to use:</Text>
              {templates.filter(x => forceTemplateId ? x.id === forceTemplateId : !!x.target && x.target.id === selectedTarget.value).map(xx => {
                return (
                  <Item onClick={() => setSelectedTemplate(xx)}>
                    <Flex flexDirection={'column'}>
                      <Text fontWeight={600}>{xx.name}</Text>
                      {xx.description && (
                        <Text mt={2}>{xx.description}</Text>
                      )}
                      <Text mt={3} fontWeight={300} fontSize={'12px'} fontStyle={'italic'}>created by {xx.creator.firstName} - last update {moment(xx.updatedAt).format('MM-DD-YYYY hh:mmA')}</Text>
                    </Flex>
                  </Item>
                )
              })}
            </>
          )}
        </>
      )}
      {selectedTemplate && (
        <>
          <Flex mb={4}></Flex>
          <Formik
            initialValues={{
              name: selectedTemplate.name,
              description: selectedTemplate.description
            }}
            isInitialValid={() => {
              try {
                const aa = schema.isValidSync({
                  name: selectedTemplate.name,
                  description: selectedTemplate.description
                });

                if (!aa) {
                  return false;
                }
                return true;
              } catch (err) {
                return false;
              }
            }}
            validationSchema={schema}
            onSubmit={(values) => onSelected(
              selectedTemplate,
              {
                name: values.name,
                description: values.description,
                version: '1',
                basedOnTemplate: selectedTemplate.id,
                targetName: selectedTemplate.target.target,
                target: selectedTemplate.target.id
              } as IFormMeta
            )}
          >
            {({ touched, errors, isValid, values }) => {
              return (
                <>
                  <Form>
                    <FormField mb={3} error={touched.name && errors.name}>
                      <TextInputWithLabel placeholder="Form name (you can change it)" name="name" id="input_name" />
                    </FormField>

                    <FormField mb={4} error={touched.description && errors.description}>
                      <TextInputWithLabel placeholder="Form description" name="description" id="input_name" />
                    </FormField>
                    <Flex alignItems="center" flexDirection="column">
                      <Button disabled={!isValid} variant="primary" width={1 / 2} type="submit" id="btn_login">
                        Create
                      </Button>
                    </Flex>
                  </Form>

                </>
              );
            }}
          </Formik>
        </>
      )}
    </Flex>
  )
}

export default PickTemplate